// Pages the config API redirects the consent popup back to. The API only
// honours a return URL that ends with one of these paths and whose origin is
// on its allowlist, so they must match the router entries for the callbacks.
export const NDR_CALLBACK_PATH = "/ndr/callback";
export const AZURE_CALLBACK_PATH = "/azure/callback";

/** The slice of a vue-router instance this helper needs. */
export interface RouterBaseSource {
  options?: { history?: { base?: string } };
}

/**
 * Absolute URL of one of this app's callback pages, as seen from the browser
 * running it: the current origin plus the router base plus the path.
 *
 * The base matters standalone: review apps build under a VITE_BASE such as
 * `/review/<iid>/dev/latest/`, and their callback page lives under it.
 * Embedded, the host's handshake is keyed on the tag the opener wrote into
 * the popup, whatever the path (see remote/consentPopup.ts), so carrying the
 * host's `/titan` base costs nothing there and keeps titan's own callback page
 * reachable should a popup ever come back untagged.
 */
export const buildAppReturnUrl = (
  router: RouterBaseSource | undefined,
  path: string,
): string => {
  const base = (router?.options?.history?.base ?? "").replace(/\/+$/, "");
  const normalisedPath = path.startsWith("/") ? path : `/${path}`;
  return new URL(
    `${base}${normalisedPath}`,
    globalThis.location.origin,
  ).toString();
};
